<template>
  <div class="regInstitution" v-loading="loading">
    <NewHeader></NewHeader>
    <!-- 标题 -->
    <div class="institution-title">
      <!-- <img src="../assets/img/regInstitution/hengfeng_title.png" alt /> -->
      <HeadTitle></HeadTitle>
    </div>
    <!-- 导航 -->
    <div class="navigation">
      <span class="color-blue cur-pointer" @click="$router.push({path:'/'})">首页</span>
      <span
        class="cur-pointer color-blue"
        @click="toHengFengPage"
        v-show="isChildPage"
      >&nbsp;/&nbsp;横峰县副中心</span> &nbsp;/
      &nbsp;平台注册专家
    </div>
    <!-- 机构 -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="hos in hosList">
          <div v-for="data in hos" class="cur-pointer" @click="toHosDetail(data.HOS_ID)">
            <img class="cur-pointer" :src="data.HOS_PHOTO" @error="hosNoError(data,'HOS_PHOTO')" />
            <div>
              <div class="text-over" :title="data.HOS_NAME">{{data.HOS_NAME}}</div>
              <!-- <div>
                申请会诊数：
                <span>{{data.diagCount}}</span>
              </div> -->
              <div>
                签约专家数：
                <span>{{data.signCount}}</span>
              </div>
              <!-- <div>
                退约申请数：
                <span>{{data.backCount}}</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
    <NewFooter></NewFooter>
  </div>
</template>
<script>
// @ is an alias to /src
import hosNo from "../assets/img/index/lunbo.png";
import NewHeader from "../components/NewHeader.vue";
import HeadTitle from "../components/HeadTitle.vue";
import NewFooter from "../components/NewFooter.vue";
export default {
  name: "regInstitution",
  data() {
    return {
      docName: "",
      hosList: [],
      loading: false,
      isChildPage: false
    };
  },
  components: {
    NewHeader,
    HeadTitle,
    NewFooter
  },
  methods: {
    // 设置参数:

    setParams() {
      // params.append(key, value);
      let that = this;
      let params = new URLSearchParams();
      let province = that.$route.query.province;
      let city = that.$route.query.city;
      let area = that.$route.query.area;
      if (province !== undefined && province !== "") {
        this.ifShowPlatform = false;
        this.areatitle = "横峰县";
        that.isChildPage = true;

        params.append("province", province);
        params.append("city", city);
        params.append("area", area);
      } else {
        this.ifShowPlatform = true;
        this.areatitle = "上饶市";
        that.isChildPage = false;

        params = {};
      }

      return params;
    },

    setQueryParams() {
      let that = this;
      let params = {};
      params.province = that.$route.query.province;
      params.city = that.$route.query.city;
      params.area = that.$route.query.area;
      if (province !== undefined && province !== "") {
        that.isChildPage = true;
      } else {
        that.isChildPage = false;
      }
      return params;
    },

    // 跳转副中心:
    toHengFengPage() {
      let that = this;
      let params = that.setQueryParams();
      that.$router.push({ path: "/", query: params });
    },

    hosNoError(d, name) {
      //图片error处理
      d[name] = hosNo;
    },
    getOnline() {
      if (sessionStorage.getItem('sessionId')) {
        var params = new URLSearchParams();
        params.append("sessionId", sessionStorage.getItem('sessionId'));
        this.$ajax
          .post("getSessionIdIsExist", params)
          .then(response => {
            if (response.result) {
              this.docName = response.user.username;
            }
          })
          .catch(error => {});
      }
    },
    logout() {
      var params = new URLSearchParams();
      params.append("sessionId", sessionStorage.getItem('sessionId'));
      this.$ajax
        .post("logout", params)
        .then(response => {
          if (response.result) {
            this.docName = "";
            sessionStorage.removeItem('sessionId');
            this.$common.removeCookie("token");
          }
          this.codeBtn();
        })
        .catch(error => {});
    },
    getHos() {
      let that = this;
      this.loading = true;
      var params = new URLSearchParams();

      //
      if (that.$route.query.province !== undefined) {
        // console.log('我是provice', that.$route.query.province)
        params.append("province", that.$route.query.province);
        params.append("city", that.$route.query.city);
        params.append("area", that.$route.query.area);
      } else {
        params = {};
      }
      this.$ajax
        .post("homePage/queryHospitalsList", params)
        .then(response => {
          this.loading = false;
          if (response.result) {
            let hos = [];
            for (let i = 0; i < response.hosList.length; i++) {
              hos.push(response.hosList[i]);
              if ((i + 1) % 9 == 0 || i == response.hosList.length - 1) {
                this.hosList.push(hos);
                hos = [];
              }
            }
            setTimeout(function() {
              new that.$swiper(".swiper-container", {
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                  renderBullet: function(index, className) {
                    return (
                      '<span class="' +
                      className +
                      '">' +
                      (index + 1) +
                      "</span>"
                    );
                  }
                }
              });
            });
          }
        })
        .catch(error => {
          this.loading = false;
        });
    },
    toHosDetail(hosId) {
      console.log(hosId);
      let that = this;
      let params = that.$router.push({
        path: "expertsRegi",
        query: { organ_id: hosId }
      });
    }
  },

  created() {
    this.getOnline();
    this.getHos();
  },
  mounted() {}
};
</script>
<style  lang="stylus">
.regInstitution
  .head
    height 64px
    background #fff
    color #fff
    z-index 99
    opacity 0.8
    width 100%
    position fixed
    top 0
    >div
      width 1200px
      margin 0 auto
      img
        // width: 132px;
        height 48px
        float left
        margin-top 10px
      .login-ent
        a
          cursor pointer
          display inline-block
          float right
          height 64px
          width 140px
          line-height 64px
          color #000
          text-align center
          font-size 1.3em
  .institution-title
    margin-top 100px
    text-align center
    img
      height 75px
  .navigation
    font-size 16px
    width 1200px
    margin 50px auto 0px auto
    border-bottom 2px solid #E1E1E1
    padding-bottom 20px
  .swiper-container
    width 1200px
    height 510px
    padding 20px 5px 0px 5px
    margin-bottom 80px
    .swiper-slide
      >div
        margin 5px
        float left
        width calc(33.3333% - 10px)
        height 128px
        display flex
        // font-size 17px
        box-shadow 0px 0px 8px rgba(208, 232, 242, 1)
        >div
          font-size 15px
          margin-top 16px
          >div
            margin-bottom 5px
            color #666666
            span
              color #0080CB
            &:first-child
              font-size 18px
              color #0080CB
        img
          width 160px
          height 100px
          margin 10px 30px 10px 15px
  .swiper-pagination-bullet
    width 32px
    height 32px
    text-align center
    line-height 32px
    font-size 14px
    color #0080CB
    opacity 1
    background #EEEEEE
  .swiper-pagination-bullet-active
    color #fff
    background #0080CB
</style>
